(function () {
  window.__ecwGiftConfig = window.__ecwGiftConfig || {};
  window.__ecwLastBundleCartAdd = 0;

  var MIN_GIFT_QTY = 3;

  function isGiftEligibleQty(qty) {
    return (parseInt(qty, 10) || 0) >= MIN_GIFT_QTY;
  }

  var GIFT_REMOVAL_GRACE_MS = 5000;

  function getGiftProps() {
    var cfg = window.__ecwGiftConfig;
    return {
      key: cfg.giftPropertyKey || 'Wasserdichte Tasche',
      value: cfg.giftPropertyValue || 'Gratis'
    };
  }

  function getFormGiftField(form, name) {
    if (!form) return '';
    var el = form.querySelector('[name="' + name + '"]');
    if (el && el.value != null && String(el.value).trim() !== '') return String(el.value).trim();
    if (form.id) {
      el = document.querySelector('[name="' + name + '"][form="' + form.id + '"]');
      if (el && el.value != null && String(el.value).trim() !== '') return String(el.value).trim();
    }
    return '';
  }

  function collectFormProperties(formData) {
    var props = {};
    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match) props[match[1]] = value;
    });
    return props;
  }

  function getGiftColorForForm(form) {
    var color = getFormGiftField(form, 'properties[_bundle_gift_color]').toLowerCase();
    if (color === 'white' || color === 'black') return color;
    return 'black';
  }

  function getGiftVariantIdForColor(color) {
    var cfg = window.__ecwGiftConfig || {};
    var id = color === 'white' ? cfg.whiteVariantId : cfg.blackVariantId;
    id = parseInt(id, 10);
    return id > 0 ? id : null;
  }

  function pickAvailableVariantId(product) {
    if (!product || !product.variants || !product.variants.length) return null;
    for (var i = 0; i < product.variants.length; i += 1) {
      var variant = product.variants[i];
      if (variant && variant.available === true && variant.id) return variant.id;
    }
    return null;
  }

  function rememberGiftVariant(color, variantId) {
    if (!window.__ecwGiftConfig) window.__ecwGiftConfig = {};
    if (color === 'white') window.__ecwGiftConfig.whiteVariantId = variantId || null;
    else window.__ecwGiftConfig.blackVariantId = variantId || null;
  }

  function cartAddFailed(res) {
    if (!res) return true;
    if (res.items || res.key || res.variant_id || res.product_id || res.id) {
      return typeof res.status === 'number' && res.status >= 400;
    }
    return typeof res.status === 'number' && res.status >= 400;
  }

  function fetchJsonTimeout(url, opts, ms) {
    return Promise.race([
      fetch(url, opts).then(function (r) { return r.json(); }),
      new Promise(function (_, reject) {
        setTimeout(function () { reject(new Error('timeout')); }, ms || 4000);
      })
    ]);
  }

  async function postCartItems(items, withSections) {
    var payload = { items: items };
    if (withSections) {
      payload.sections = ['cart-drawer', 'cart-icon-bubble'];
      payload.sections_url = window.location.pathname;
    }
    return fetchJsonTimeout((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }, 8000);
  }

  function giftAddSucceeded(res) {
    if (!res || typeof res !== 'object') return false;
    if (typeof res.status === 'number' && res.status >= 400) return false;
    if (res.description && /sold out|agotad|ausverkauft|nicht verf/i.test(String(res.description))) return false;
    return !!(res.items && res.items.length) || !!res.key || !!res.variant_id;
  }

  async function cartHasGift() {
    var cart = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
    if (!cart || !cart.items) return false;
    return cart.items.some(function (item) {
      return window.__ecwIsBundleGiftItem && window.__ecwIsBundleGiftItem(item);
    });
  }

  async function resolveGiftVariantId(color) {
    var handle = getGiftHandleForColor(color);
    if (!handle) return null;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    try {
      var response = await fetch(root + 'products/' + handle + '.js', {
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (!response.ok) {
        rememberGiftVariant(color, null);
        return null;
      }
      var product = await response.json();
      var variantId = pickAvailableVariantId(product);
      rememberGiftVariant(color, variantId);
      return variantId || null;
    } catch (err) {
      return null;
    }
  }

  async function resolveDesiredGift(preferredColor) {
    var first = preferredColor === 'white' ? 'white' : 'black';
    var second = first === 'white' ? 'black' : 'white';
    var firstId = await resolveGiftVariantId(first);
    if (firstId) return { color: first, variantId: firstId, handle: getGiftHandleForColor(first) };
    var secondId = await resolveGiftVariantId(second);
    if (secondId) return { color: second, variantId: secondId, handle: getGiftHandleForColor(second) };
    return null;
  }

  async function postGiftVariant(giftVariantId, properties) {
    return fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{
          id: Number(giftVariantId),
          quantity: 1,
          properties: properties || {}
        }]
      })
    }).then(function (r) { return r.json(); });
  }

  async function addGiftByVariantId(giftVariantId) {
    if (!giftVariantId) return false;
    if (await cartHasGift()) return true;
    var giftProps = getGiftProps();
    var giftLineProps = { '_bundle_gift_auto': 'true' };
    giftLineProps[giftProps.key] = giftProps.value;
    try {
      var giftRes = await postGiftVariant(giftVariantId, giftLineProps);
      if (giftAddSucceeded(giftRes) && await cartHasGift()) return true;
      if (await cartHasGift()) return true;
      giftRes = await postGiftVariant(giftVariantId, {});
      if (giftAddSucceeded(giftRes)) return true;
      return cartHasGift();
    } catch (err) {
      console.error('Gift bag not added:', err);
      return false;
    }
  }

  async function tryAddGiftBag(color) {
    try {
      if (await cartHasGift()) return true;
      var desired = await resolveDesiredGift(color || 'black');
      if (!desired) return false;
      return addGiftByVariantId(desired.variantId);
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  window.__ecwAddGiftBagAfterProduct = async function (form) {
    var shouldAdd = typeof window.__ecwShouldAddBundleGift === 'function'
      ? window.__ecwShouldAddBundleGift(form)
      : false;
    if (!shouldAdd) return false;
    window.__ecwMarkCartAdd();
    return tryAddGiftBag(getGiftColorForForm(form) || 'black');
  };

  function getGiftHandleForColor(color) {
    var cfg = window.__ecwGiftConfig;
    if (color === 'white') return cfg.whiteHandle || 'gratis-oko-wet-bag-weiss-regalo';
    return cfg.blackHandle || 'gratis-oko-wet-bag-schwarz-regalo';
  }


  function inferFreeQtyFromPaid(paidQty) {
    var paid = parseInt(paidQty, 10) || 0;
    if (paid === 2) return 1;
    if (paid === 4) return 2;
    if (paid === 6) return 3;
    return 0;
  }

  function getCheckedBundleRadio() {
    return document.querySelector('.bundle-choices--free-units .bundle-choices__radio:checked')
      || document.querySelector('.bundle-choices__radio:checked');
  }

  function receiveQtyFromRadio(radio) {
    if (!radio) return 0;
    var paid = parseInt(radio.getAttribute('data-paid-qty') || radio.getAttribute('data-qty'), 10) || 0;
    var free = parseInt(radio.getAttribute('data-free-qty'), 10) || 0;
    var receive = parseInt(radio.getAttribute('data-receive-qty'), 10) || 0;
    var rootEl = radio.closest('.bundle-choices');
    if (rootEl && rootEl.classList.contains('bundle-choices--free-units')) {
      return receive || (paid + free) || paid;
    }
    return paid || receive;
  }

  window.__ecwGetAddQty = function (form) {
    var radio = getCheckedBundleRadio();
    if (radio) {
      var rootEl = radio.closest('.bundle-choices');
      if (rootEl && rootEl.classList.contains('bundle-choices--free-units')) {
        var paid = parseInt(radio.getAttribute('data-paid-qty') || radio.getAttribute('data-qty'), 10) || 0;
        var free = parseInt(radio.getAttribute('data-free-qty'), 10) || 0;
        var receive = parseInt(radio.getAttribute('data-receive-qty'), 10) || 0;
        var addQty = receive > 0 ? receive : (paid + free);
        return addQty > 0 ? addQty : 1;
      }
      var fromRadio = receiveQtyFromRadio(radio);
      if (fromRadio > 0) return fromRadio;
    }

    var promo = window.__ecwCurrentPromo;
    if (promo && promo.enabled) {
      var paid = parseInt(promo.paidQty, 10) || 0;
      var free = parseInt(promo.freeQty, 10) || 0;
      if (paid + free > 0) return paid + free;
    }

    if (form) {
      var hidden = form.querySelector('input.bundle-qty[name="quantity"]');
      var hiddenQty = parseInt(hidden && hidden.value, 10) || 0;
      if (hiddenQty > 0) return hiddenQty;
    }

    return parseInt((form && form.querySelector('[name="quantity"]') || {}).value || '1', 10) || 1;
  };

  function isFreeUnitsPromoEnabled() {
    if (window.__ecwCurrentPromo && window.__ecwCurrentPromo.enabled) return true;
    if (window.__ecwPromoType === 'free_units') return true;
    return false;
  }

  function getFreeUnitsFromForm(form) {
    var promo = getFormGiftField(form, 'properties[_ecowoman_promo]');
    var freeQty = parseInt(getFormGiftField(form, 'properties[_ecowoman_free_qty]') || '0', 10);
    var tier = getFormGiftField(form, 'properties[_ecowoman_tier]');
    var paidQty = 0;
    if (form) {
      paidQty = parseInt((form.querySelector('[name="quantity"]') || {}).value || '0', 10) || 0;
    }
    if (window.__ecwCurrentPromo && window.__ecwCurrentPromo.enabled) {
      if (!promo) promo = 'free_units';
      if (!freeQty) freeQty = parseInt(window.__ecwCurrentPromo.freeQty, 10) || 0;
      if (!tier) tier = window.__ecwCurrentPromo.tier || '';
      if (!paidQty) paidQty = parseInt(window.__ecwCurrentPromo.paidQty, 10) || 0;
    }
    if (!freeQty && isFreeUnitsPromoEnabled()) {
      freeQty = inferFreeQtyFromPaid(paidQty);
    }
    return {
      enabled: promo === 'free_units' || (isFreeUnitsPromoEnabled() && freeQty > 0),
      freeQty: freeQty,
      tier: tier || '',
      paidQty: paidQty
    };
  }

  window.__ecwShouldAddPromoItems = function () {
    return false;
  };

  var DEFAULT_PAD_HANDLES = [
    'waschbare-binden-mittlerer-durchfluss',
    'waschbare-binden-mittlerer-durchfluss-weiss',
    'waschbare-binden-starker-durchfluss',
    'waschbare-binden-starker-durchfluss-weiss',
    'waschbare-slipeinlagen',
    'waschbare-slipeinlagen-weiss'
  ];

  function isPadHandleOrTitle(handle, title) {
    var h = (handle || '').toLowerCase();
    var t = (title || '').toLowerCase();
    var cfg = window.__ecwGiftConfig || {};
    var padHandles = cfg.padHandles || DEFAULT_PAD_HANDLES;
    if (padHandles.indexOf(h) !== -1) return true;
    return h.indexOf('waschbare') !== -1 ||
      h.indexOf('binden') !== -1 ||
      h.indexOf('slipeinlage') !== -1 ||
      h.indexOf('wiederverwendbar') !== -1 ||
      t.indexOf('binden') !== -1 ||
      t.indexOf('slipeinlage') !== -1 ||
      t.indexOf('waschbare') !== -1 ||
      t.indexOf('wiederverwendbar') !== -1;
  }

  function isCurrentProductPad() {
    var handle = '';
    var handleEl = document.querySelector('[data-product-handle]');
    if (handleEl && handleEl.getAttribute('data-product-handle')) {
      handle = String(handleEl.getAttribute('data-product-handle')).toLowerCase();
    } else {
      var match = (window.location.pathname || '').match(/\/products\/([^/?#]+)/);
      if (match) handle = decodeURIComponent(match[1]).toLowerCase();
    }
    return isPadHandleOrTitle(handle, '');
  }

  window.__ecwShouldAddBundleGift = function (form) {
    if (!form) return false;
    var eligible = getFormGiftField(form, 'properties[_bundle_gift_eligible]');
    var packQty = parseInt(getFormGiftField(form, 'properties[_bundle_gift_qty]') || '0', 10);
    if (eligible === 'true' && isGiftEligibleQty(packQty)) return true;
    if (!isCurrentProductPad()) return false;
    if (!packQty && typeof window.__ecwGetAddQty === 'function') {
      packQty = window.__ecwGetAddQty(form);
    }
    return isGiftEligibleQty(packQty);
  };

  window.__ecwMarkCartAdd = function () {
    window.__ecwLastBundleCartAdd = Date.now();
  };

  window.__ecwRecentlyAddedBundle = function () {
    return Date.now() - (window.__ecwLastBundleCartAdd || 0) < GIFT_REMOVAL_GRACE_MS;
  };

  function cartSectionsLookEmpty(html) {
    if (!html) return true;
    if (html.indexOf('cart-item') !== -1 || html.indexOf('CartItem-') !== -1 || html.indexOf('CartDrawer-Item') !== -1) return false;
    return html.indexOf('drawer__inner-empty') !== -1;
  }

  window.__ecwFetchCartSections = async function (cartComponent) {
    if (!cartComponent || typeof cartComponent.getSectionsToRender !== 'function') return {};
    var ids = cartComponent.getSectionsToRender().map(function (section) {
      return section.id;
    });
    if (!ids.length) return {};
    var url = window.location.pathname + '?sections=' + ids.join(',');
    var response = await fetch(url, { credentials: 'same-origin' });
    return response.json();
  };

  window.__ecwRefreshCartDrawer = async function () {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    var response = await fetch(cartUrl + '?section_id=cart-drawer&ecw=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store'
    });
    var htmlText = await response.text();
    var doc = new DOMParser().parseFromString(htmlText, 'text/html');

    ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (selector) {
      var target = document.querySelector(selector);
      var source = doc.querySelector(selector);
      if (target && source) target.replaceWith(source);
    });

    var newDrawer = doc.querySelector('cart-drawer');
    var currentDrawer = document.querySelector('cart-drawer');
    if (newDrawer && currentDrawer) {
      currentDrawer.classList.toggle('is-empty', newDrawer.classList.contains('is-empty'));
    }

    var emptyEl = document.querySelector('.drawer__inner-empty');
    if (emptyEl && newDrawer && !newDrawer.classList.contains('is-empty')) {
      emptyEl.remove();
    }
    if (currentDrawer && newDrawer && !newDrawer.classList.contains('is-empty')) {
      currentDrawer.classList.remove('is-empty');
    }

    var bubbleData = await fetch(window.location.pathname + '?sections=cart-icon-bubble', {
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); }).catch(function () { return {}; });

    var bubbleEl = document.getElementById('cart-icon-bubble');
    if (bubbleEl && bubbleData['cart-icon-bubble']) {
      var parsed = new DOMParser().parseFromString(bubbleData['cart-icon-bubble'], 'text/html');
      var inner = parsed.querySelector('.shopify-section');
      if (inner) bubbleEl.innerHTML = inner.innerHTML;
    }

    if (currentDrawer && typeof currentDrawer.open === 'function' && currentDrawer.classList.contains('active')) {
      var overlay = currentDrawer.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', currentDrawer.close.bind(currentDrawer));
    }
  };

  window.__ecwEnsureFreeUnitsForCart = async function () {
    return false;
  };

  window.__ecwAddPromoItems = async function (form) {
    return window.__ecwAddBundleProductAndGift(form);
  };

  window.__ecwAddBundleProductAndGift = async function () {
    return null;
  };

  function isBundleGiftHandle(handle) {
    var cfg = window.__ecwGiftConfig || {};
    return handle === (cfg.whiteHandle || 'gratis-oko-wet-bag-weiss-regalo') ||
      handle === (cfg.blackHandle || 'gratis-oko-wet-bag-schwarz-regalo');
  }

  function isPadCartItem(item) {
    if (!item) return false;
    return isPadHandleOrTitle(item.handle, item.product_title || item.title);
  }

  window.__ecwIsBundleGiftItem = function (item) {
    if (!item) return false;
    if (isBundleGiftHandle(item.handle)) return true;
    if (item.properties && item.properties._bundle_gift_auto != null &&
      String(item.properties._bundle_gift_auto).trim() !== '') return true;
    var title = ((item.product_title || item.title || '') + '').toLowerCase();
    return (parseInt(item.final_price, 10) || 0) === 0 &&
      (title.indexOf('wet bag') !== -1 || title.indexOf('wet-bag') !== -1 ||
        title.indexOf('tasche') !== -1 ||
        (title.indexOf('bolsita') !== -1 && title.indexOf('regalo') !== -1));
  };

  function getPadLineItems(cart) {
    if (!cart || !cart.items) return [];
    return cart.items.filter(function (item) {
      return item && !window.__ecwIsBundleGiftItem(item) && isPadCartItem(item);
    });
  }

  function getPadPackSizeFromItem(item) {
    if (!item) return 1;
    var textParts = [item.variant_title, item.title, item.product_title];
    if (item.options_with_values && item.options_with_values.length) {
      item.options_with_values.forEach(function (opt) {
        if (opt && opt.value) textParts.push(opt.value);
      });
    }
    var text = textParts.filter(Boolean).join(' ').toLowerCase();
    if (!text) return 1;
    var match = text.match(/(\d+)\s*er[\s-]*pack/);
    if (match) return parseInt(match[1], 10) || 1;
    match = text.match(/(\d+)\s*[- ]?\s*pack/);
    if (match) return parseInt(match[1], 10) || 1;
    match = text.match(/pack(?:ung)?\s*(?:mit|de|of)?\s*(\d+)/);
    if (match) return parseInt(match[1], 10) || 1;
    match = text.match(/(\d+)\s*(?:x|stück|stk|units?)/);
    if (match) return parseInt(match[1], 10) || 1;
    return 1;
  }

  function getPadItemEffectiveQty(item) {
    var lineQty = parseInt(item.quantity, 10) || 0;
    return lineQty * getPadPackSizeFromItem(item);
  }

  function getTotalPadQty(cart) {
    return getPadLineItems(cart).reduce(function (total, item) {
      return total + getPadItemEffectiveQty(item);
    }, 0);
  }

  function getGiftColorForPadItem(item) {
    var color = 'black';
    var handle = (item.handle || '').toLowerCase();
    var colorProp = item.properties && item.properties._bundle_gift_color
      ? String(item.properties._bundle_gift_color).toLowerCase()
      : '';
    if (colorProp === 'white' || colorProp === 'black') {
      color = colorProp;
    } else if (handle.indexOf('white') !== -1 || handle.indexOf('blanco') !== -1 ||
      handle.indexOf('weiss') !== -1 || handle.indexOf('weiß') !== -1) {
      color = 'white';
    } else if (handle.indexOf('black') !== -1 || handle.indexOf('negro') !== -1 ||
      handle.indexOf('night') !== -1 || handle.indexOf('noche') !== -1 ||
      handle.indexOf('schwarz') !== -1) {
      color = 'black';
    }
    return color;
  }

  window.__ecwGetPadItemEffectiveQty = getPadItemEffectiveQty;
  window.__ecwGetTotalPadQty = getTotalPadQty;

  window.__ecwIsCartGiftEligible = function (cart) {
    return getTotalPadQty(cart) >= MIN_GIFT_QTY;
  };

  window.__ecwHasEligiblePackLine = function (cart) {
    return window.__ecwIsCartGiftEligible(cart);
  };

  window.__ecwGetDesiredGiftColor = function (cart) {
    var padItems = getPadLineItems(cart);
    if (!padItems.length) return 'black';
    padItems.sort(function (a, b) {
      return (parseInt(b.quantity, 10) || 0) - (parseInt(a.quantity, 10) || 0);
    });
    return getGiftColorForPadItem(padItems[0]);
  };

  window.__ecwRemoveOrphanGifts = async function (cartOptional, options) {
    if (window.__ecwRecentlyAddedBundle && window.__ecwRecentlyAddedBundle()) return false;
    var cart = cartOptional;
    if (!cart || !cart.items) {
      cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }

    if (window.__ecwIsCartGiftEligible(cart)) return false;

    return window.__ecwRemoveAllGiftsFromCart(cart);
  };

  window.__ecwRemoveAllGiftsFromCart = async function (cartOptional) {
    var cart = cartOptional;
    if (!cart || !cart.items) {
      cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }

    var updates = {};
    cart.items.forEach(function (item) {
      if (window.__ecwIsBundleGiftItem(item)) {
        updates[item.key] = 0;
      }
    });

    if (Object.keys(updates).length === 0) return false;

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    });

    if (typeof window.__ecwRefreshCartDrawer === 'function') {
      await window.__ecwRefreshCartDrawer();
    }

    return true;
  };

  window.__ecwSyncGiftBagForCart = async function (opts) {
    var cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    var totalPads = getTotalPadQty(cart);

    if (totalPads < MIN_GIFT_QTY) {
      if (window.__ecwRecentlyAddedBundle && window.__ecwRecentlyAddedBundle()) return false;
      return window.__ecwRemoveAllGiftsFromCart(cart);
    }

    var padItems = getPadLineItems(cart);
    if (!padItems.length) return false;

    padItems.sort(function (a, b) {
      return (parseInt(b.quantity, 10) || 0) - (parseInt(a.quantity, 10) || 0);
    });

    var preferred = getGiftColorForPadItem(padItems[0]);
    var desired = await resolveDesiredGift(preferred);
    if (!desired) return false;
    var color = desired.color;
    var desiredHandle = desired.handle;
    var desiredVariantId = desired.variantId;

    var giftItems = cart.items.filter(function (item) {
      return window.__ecwIsBundleGiftItem(item);
    });
    var correctGift = giftItems.filter(function (item) {
      return item.handle === desiredHandle;
    });
    var wrongGifts = giftItems.filter(function (item) {
      return item.handle !== desiredHandle;
    });

    var updates = {};
    wrongGifts.forEach(function (item) {
      updates[item.key] = 0;
    });

    if (correctGift.length > 1) {
      var kept = false;
      correctGift.forEach(function (item) {
        if (!kept) {
          if ((parseInt(item.quantity, 10) || 0) !== 1) updates[item.key] = 1;
          kept = true;
        } else {
          updates[item.key] = 0;
        }
      });
    } else if (correctGift.length === 1) {
      var onlyGift = correctGift[0];
      if ((parseInt(onlyGift.quantity, 10) || 0) !== 1) {
        updates[onlyGift.key] = 1;
      }
    }

    if (Object.keys(updates).length > 0) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
        body: JSON.stringify({ updates: updates })
      });
    }

    if (correctGift.length === 0) {
      var addedGift = await tryAddGiftBag(color);
      if (!addedGift) return false;
    }

    if (Object.keys(updates).length > 0 || correctGift.length === 0) {
      if (!(opts && opts.skipRefresh) && typeof window.__ecwRefreshCartDrawer === 'function') {
        await window.__ecwRefreshCartDrawer();
      }
      return true;
    }

    return false;
  };

  window.__ecwEnsureGiftForCart = async function () {
    var cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    if (getTotalPadQty(cart) < MIN_GIFT_QTY) return false;

    var padItems = getPadLineItems(cart);
    if (!padItems.length) return false;

    padItems.sort(function (a, b) {
      return (parseInt(b.quantity, 10) || 0) - (parseInt(a.quantity, 10) || 0);
    });

    var giftProps = getGiftProps();
    var giftLineProps = { '_bundle_gift_auto': 'true' };
    giftLineProps[giftProps.key] = giftProps.value;

    var preferred = getGiftColorForPadItem(padItems[0]);
    var desired = await resolveDesiredGift(preferred);
    if (!desired) return false;
    var color = desired.color;
    var desiredHandle = desired.handle;
    var desiredVariantId = desired.variantId;

    var hasGift = cart.items.some(function (item) {
      return item.handle === desiredHandle || window.__ecwIsBundleGiftItem(item);
    });
    if (hasGift) return false;

    var giftRes = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{
          id: Number(desiredVariantId),
          quantity: 1,
          properties: giftLineProps
        }]
      })
    }).then(function (r) { return r.json(); });

    return !giftRes.status;
  };
})();
